import { Switch, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Model from '../models/model';
import { dataStore } from '../Store';

const hideForRoles = () => {
	const { auth = {} } = dataStore?.getState() || {};
	const { LicenseAppName } = auth.tags;
	return LicenseAppName.includes('catviewer');
}
const CustomSwitch = styled(Switch)(({ theme }) => ({
	padding: 8,
	'& .MuiSwitch-track': {
		borderRadius: 22 / 2,
		'&:before, &:after': {
			content: '""',
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			width: 16,
			height: 16
		},
		'&:before': {
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
			left: 12
		},
		'&:after': {
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}" d="M19,13H5V11H19V13Z" /></svg>')`,
			right: 12
		}
	},
	'& .MuiSwitch-thumb': {
		boxShadow: 'none',
		width: 16,
		height: 16,
		margin: 2
	}
}));

const CustomSwitchInput = ({ Input, inputProps: { field, formik } }) => (
	<Grid container>
		<CustomSwitch checked={formik.values[field]} onChange={formik.handleChange} name={field} color="success" />
	</Grid>
);

const model = new Model({
	name: 'PrintConfig',
	sortable: false,
	disableAdd: true,
	disableDelete: true,
	disableExport: true,
	showGridRefreshBtn: true,
	combos: [
		{ type: 'CycleGraphSize', loaded: true },
		{ type: 'ContentDisplayType', loaded: true },
		{ type: 'BarcodeConfig', loaded: true }
	],
	customizeSaveData: (values, { activeRecord }) => {
		return {
			_id: activeRecord.record?._id,
			...values
		}
	},
	formGroupsComponent: 'accordions',
	formGroups: [
		{
			header: 'PrintConfig',
			fields: ['CycleGraphSizeId', 'IsCriticalParameterDisplay', 'IsCycleTapeDisplay'],
			columnSize: 4,
			fieldProps: {
				inlineLabelSize: 6
			},
			headerProps: {
				sx: {
					textTransform: 'none',
				}
			},
			visible: ({ activeRecord }) => hideForRoles() && activeRecord?.formGroupsVisibility?.get?.('PrintConfig')
		},
		{
			header: 'HeaderFooter',
			fields: [
				'EquipmentDisplayId',
				'EquipmentTypeDisplayId',
				'EquipmentModelDisplayId',
				'EquipmentSerialDisplayId',
				'LocationIdDisplayId',
				'CycleNumberDisplayTypeId',
				'CycleDateDisplayTypeId',
				'PageNumberDisplayId'
			],
			columnSize: 4,
			fieldProps: {
				inlineLabelSize: 6
			},
			headerProps: {
				sx: {
					textTransform: 'none'
				}
			},
			visible: ({ activeRecord }) => hideForRoles() && activeRecord?.formGroupsVisibility?.get?.('HeaderFooter')
		},
		{
			header: 'PrintBarcodeConfiguration',
			fields: [
				'BarcodeHeightWidth',
				'UserItemName',
				'ItemSerialNumber'
			],
			columnSize: 6,
			fieldProps: {
				inlineLabelSize: 4
			},
			headerProps: {
				sx: {
					textTransform: 'none'
				}
			},
			visible: ({ activeRecord }) => activeRecord?.formGroupsVisibility?.get?.('PrintBarcodeConfiguration')
		}
	],
	columns: [
		{
			field: 'CycleGraphSizeId',
			header: 'CycleGraph',
			lookup: 'CycleGraphSize',
			disableClearable: true,
			readOnly: ({ formik }) => !formik?.values?.IsCycleTapeDisplay
		},

		{
			field: 'IsCriticalParameterDisplay',
			header: 'CriticalParameterDisplay',
			type: 'boolean',
			customizeInput: CustomSwitchInput
		},
		{
			field: 'IsCycleTapeDisplay',
			header: 'CycleType',
			type: 'boolean',
			customizeInput: CustomSwitchInput
		},
		{
			field: 'EquipmentDisplayId',
			header: 'Equipment',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'EquipmentTypeDisplayId',
			header: 'EquipmentType',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'EquipmentModelDisplayId',
			header: 'EquipmentModel',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'EquipmentSerialDisplayId',
			header: 'SerialNumber',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'LocationIdDisplayId',
			header: 'Location',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'CycleNumberDisplayTypeId',
			header: 'CycleNumber',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'CycleDateDisplayTypeId',
			header: 'CycleDateTime',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'PageNumberDisplayId',
			header: 'PageNumber',
			lookup: 'ContentDisplayType',
			disableClearable: true
		},
		{
			field: 'BarcodeHeightWidth',
			header: 'BarcodeHeightWidth',
			required: true,
			disableClearable: true,
			lookup: 'BarcodeConfig'
		},
		{
			field: 'UserItemName',
			header: 'UserItemName',
			required: true,
			type: 'boolean',
			disableClearable: true,
			customizeInput: CustomSwitchInput,
			readOnly: true
		},
		{
			field: 'ItemSerialNumber',
			header: 'SerialNumberSecond',
			required: true,
			type: 'boolean',
			disableClearable: true,
			customizeInput: CustomSwitchInput,
			readOnly: true
		}
	]
});

export default model.createFormDialog();
